import clsx from 'clsx';
import React from 'react';

export const FilterSortLineSkeleton: React.FC = () => (
  <div className='relative mb-6 flex animate-pulse flex-row place-items-center justify-between'>
    {Array.from({ length: 2 }).map((_, index) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className={clsx('flex h-11 w-[129px] items-center gap-2 rounded-full bg-gray-200 md:h-[50px]', index === 1 && 'md:w-[274px]')}
      />
    ))}
  </div>
);
